import {Component, inject, input, InputSignal, output, OutputEmitterRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxLookupModule} from 'devextreme-angular';
import {ContratMenuConvive__ModeleNutriDTO} from '../../../../../core/dtos/contratmenuconvive__modele-nutri-dto';
import {UtilsService} from '../../../../../core/utils/utils.service';
import * as moment from 'moment';

@Component({
  selector: 'yo-periode-lookup',
  templateUrl: './periode-lookup.component.html',
  styleUrls: ['./periode-lookup.component.scss'],
  standalone: true,
  imports: [CommonModule, DxLookupModule]
})
export class PeriodeLookupComponent {

  periodeList: InputSignal<ContratMenuConvive__ModeleNutriDTO[]> = input<ContratMenuConvive__ModeleNutriDTO[]>([]);
  selectedPeriodeId: InputSignal<number | undefined> = input<number>();
  placeholder: InputSignal<string> = input<string>('sélection...');

  onPeriodeChange: OutputEmitterRef<ContratMenuConvive__ModeleNutriDTO> = output<ContratMenuConvive__ModeleNutriDTO>();

  #utils = inject(UtilsService);

  displayExpr = (item: ContratMenuConvive__ModeleNutriDTO): string => {
    if (!item) return '';
    const debut = this.#utils.getFrenchDateDDMMYYYY(moment(item.dateDebut));
    const modele = item.modeleNutritionnelLibelle || '';
    if (this.#utils.isNullOrEmpty(item.dateFin)) {
      return `à partir du ${debut} (${modele})`;
    }
    const fin = this.#utils.getFrenchDateDDMMYYYY(moment(item.dateFin));
    return `${debut} au ${fin} (${modele})`;
  };

  valueChanged(event): void {
    const periode = this.periodeList()?.find(p => p.id === event.value);
    this.onPeriodeChange.emit(periode);
  }
}
